import {Component, OnInit} from '@angular/core';
import {PriceRobotCompetitorService} from "../services/price-robot-competitor.service";
import {PriceRobotFilter} from "../services/price-robot-filter";
import {PriceRobotMessageService} from "../services/price-robot-message.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-price-robot-competitors',
    templateUrl: './price-robot-competitors.component.html',
    styleUrls: ['./price-robot-competitors.component.scss']
})
export class PriceRobotCompetitorsComponent implements OnInit {
    public data: any;
    public filter: PriceRobotFilter = new PriceRobotFilter();
    public loading: boolean = false;

    constructor(private priceRobotCompetitorsService: PriceRobotCompetitorService, private priceRobotMessageService: PriceRobotMessageService, private router: Router) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        this.loading = true;
        this.priceRobotCompetitorsService.index(this.filter).subscribe(result => {
            this.loading = false;
            this.data = result['competitors'];
        }, error => {
            this.loading = false;
            this.priceRobotMessageService.handleError(error);
        })
    }


}
